<template>
  <VTDropdownPill
    :is-enabled="!disabled"
    @confirm="onConfirmClick"
    @clear="onClearClick"
    @on-click-outside="resetState"
  >
    <template #dropDownHeader>
      <VTPill label="Days">
        <template #values>
          <div v-for="day in days" :key="day.value" :class="$style.selectedDays">
            <span :class="[$style.day, { [$style.isDaySelected]: isDaySelected(day.value) }]">
              {{ day.label }}
            </span>
          </div>
        </template>
      </VTPill>
    </template>
    <template #dropdown-content>
      <div :class="$style.dropdownContainer">
        <span :class="$style.dropdownText">Days in which the offer will be shown</span>
        <div :class="$style.checkboxContainer">
          <div v-for="day in days" :key="day.value">
            <div :class="$style.checkboxColumn">
              <Checkbox v-model="selectedDays" :input-id="day.value" name="selectedDays" :value="day.value" />
              <label :for="day.value" :class="$style.label">{{ day.label }}</label>
            </div>
          </div>
        </div>
      </div>
    </template>
  </VTDropdownPill>
</template>

<script setup lang="ts">
import VTDropdownPill from "@/components/VTDropdownPill";
import VTPill from "@/components/VTPill";
import Checkbox from "primevue/checkbox";
import type { PropType } from "vue";
import { ref } from "vue";

const props = defineProps({
  modelValue: {
    type: Array as PropType<string[]>,
    required: true,
  },
  disabled: {
    type: Boolean,
    default: false,
  },
});

const emit = defineEmits(["update"]);

const selectedDays = ref(props.modelValue);

const isDaySelected = (day: string) => !!props.modelValue.find((item) => item === day);

const days = [
  { label: "M", value: "Monday" },
  { label: "T", value: "Tuesday" },
  { label: "W", value: "Wednesday" },
  { label: "T", value: "Thursday" },
  { label: "F", value: "Friday" },
  { label: "S", value: "Saturday" },
  { label: "S", value: "Sunday" },
];

const onConfirmClick = () => {
  emit("update", selectedDays.value);
};

const onClearClick = () => {
  selectedDays.value = [];
  emit("update", []);
};

const resetState = () => {
  selectedDays.value = props.modelValue;
};
</script>
<style module>
.selectedDays {
  display: flex;
  align-items: center;
  gap: 8px;
}

.day {
  height: 20px;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 20px;
}

.isDaySelected {
  font-weight: bold;
  border-bottom: 2px solid var(--vd-color-blue-default);
}

.dropdownContainer {
  display: flex;
  flex-direction: column;
  gap: 8px;
  margin-bottom: 8px;
}
.checkboxContainer {
  display: flex;
  gap: 8px;
}

.checkboxColumn {
  display: flex;
  gap: 8px;
  flex-direction: column;
}

.dropdownText {
  max-width: 184px;
}
.label {
  display: flex;
  align-items: center;
  justify-content: center;
}
</style>
